import React, { useEffect, useMemo, useState } from "react";
import { Table, Tag, Button, Space, message } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import api from "../../../api";
import { formatDateTime } from "../../../utilities/utils";

export default function Grants() {
  const { id } = useParams(); // campaignId

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const statusTag = (s) => {
    const color =
      s === "ISSUED"
        ? "green"
        : s === "PENDING"
        ? "blue"
        : s === "REVOKED"
        ? "volcano"
        : s === "EXPIRED"
        ? "red"
        : "default";
    return <Tag color={color}>{s}</Tag>;
  };

  const fetchGrants = async (p = page, l = limit) => {
    try {
      setLoading(true);
      const res = await api.get_grants_by_campaign(id, { page: p, limit: l });
      const payload = res?.data ?? res;

      // BE: { items, meta }  эсвэл { data, pagination }
      const list = payload.items || payload.data || [];
      const meta = payload.meta || payload.pagination || {};
      const totalCount = meta.total ?? meta.totalCount ?? list.length;

      setItems(Array.isArray(list) ? list : []);
      setTotal(Number(totalCount) || 0);
      setPage(meta.page || p);
      setLimit(meta.limit || l);
    } catch (e) {
      message.error(e?.message || "Grants fetch failed");
    } finally {
      setLoading(false);
    }
  };

  // id/page/limit өөрчлөгдөх бүрт ачаална
  useEffect(() => {
    if (id) fetchGrants(page, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, page, limit]);

  const onTableChange = (pagination) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  const columns = useMemo(
    () => [
      {
        title: "Утас",
        dataIndex: "phone",
        key: "phone",
        width: 140,
        render: (v) => <span code>{v || "—"}</span>,
      },
      // {
      //   title: "Бонус сугалаа",
      //   dataIndex: "bonusLotteryId",
      //   key: "bonusLotteryId",
      //   ellipsis: true,
      //   render: (v) => v || "—",
      // },
      {
        title: "Тасалбар",
        dataIndex: "bonusTickets",
        key: "bonusTickets",
        width: 140,
        render: (n) => <Tag color="blue">x{n}</Tag>,
      },
      {
        title: "Төлөв",
        dataIndex: "status",
        key: "status",
        width: 140,
        render: statusTag,
      },
      {
        title: "Reason",
        dataIndex: "reason",
        key: "reason",
        ellipsis: true,
        render: (v) => v || "—",
      },
      {
        title: "Огноо",
        dataIndex: "created_at",
        key: "created_at",
        render: (v) => formatDateTime(v) || "-",
      },
      // {
      //   title: "SourceKey",
      //   dataIndex: "sourceKey",
      //   key: "sourceKey",
      //   ellipsis: true,
      //   render: (v) => (v ? <span copyable>{v}</span> : "—"),
      // },
    ],
    []
  );

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <Space align="center" style={{ justifyContent: "space-between" }}>
        <Button
          icon={<ReloadOutlined />}
          onClick={() => fetchGrants(page, limit)}
        >
          Refresh
        </Button>
      </Space>

      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={items}
        onChange={onTableChange}
        pagination={{
          current: page,
          pageSize: limit,
          total,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
          showTotal: (t) => `Нийт ${t}`,
        }}
        scroll={{ x: 900 }}
      />
    </div>
  );
}
